
// Actions
import { createSlice } from '@reduxjs/toolkit';
export const name = 'containers/AdminManagement';

export const initialState = {
  isOpen: false
};

const adminManagementSlice = createSlice({
  name: 'containers/AdminManagement',
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.loading = false;
      state.profile = null;
      state.error = null;
      state.success = null;
    },
    searchProfile: (state) => {
      state.loading = true;
      state.profile = null;
      state.error = null;
      state.success = null;
    },
    searchProfileSucceeded: (state, { payload }) => {
      state.loading = false;
      state.profile = payload;
      state.error = null;
      state.success = null;
    },
    searchProfileFailed: (state, { payload }) => {
      state.loading = false;
      state.profile = null;
      state.error = payload;
      state.success = null;
    },
    openConfirmation: (state) => {
      state.isOpen = true;
    },
    closeConfirmation: (state) => {
      state.isOpen = false;
    },
    undeleteProfile: (state) => {
      state.isUndeletingProfile = true;
    },
    undeleteProfileSucceeded: (state) => {
      state.isOpen = false;
      state.isUndeletingProfile = false;
      state.profile = null;
      state.error = null;
      state.success = `You have successfully undeleted the Workspace/Dataset. 
        Please refresh the browser to see it available.`;
    },
    undeleteProfileFailed: (state) => {
      state.isOpen = false;
      state.isUndeletingProfile = false;
      state.profile = null;
      state.error = 'There was a problem undeleting the Workspace/Dataset';
      state.success = null;
    }
  }
});

const { actions, reducer } = adminManagementSlice;
export default reducer;
export const {
  clearSearch,
  searchProfile,
  searchProfileSucceeded,
  searchProfileFailed,
  openConfirmation,
  closeConfirmation,
  undeleteProfile,
  undeleteProfileSucceeded,
  undeleteProfileFailed
} = actions;

